import { FetchUtil } from "../util/FetchUtil";
import { IUserProfileServiceEndpoint } from "../models/UserProfile/IUserProfileServiceEndpoint";
import { IUserProfileCustomFieldResponse } from "../models/UserProfile/IUserProfileCustomFieldResponse";
import { IUserProfileCustomField } from "../models/UserProfile/IUserProfileCustomField";
import { IUserProfileSiteSettingsUpdateRequest } from "../models/UserProfile/IUserProfileSiteSettingsUpdateRequest";
import { WyanokeUtil } from "../util/WyanokeUtil";
import { StringUtil } from "../util/StringUtil";

export class UserProfileService {

    constructor(private readonly _api: IUserProfileServiceEndpoint) { }

    public async updateUserSettings(userSettings: IUserProfileSiteSettingsUpdateRequest): Promise<void> {
        const api = this._api;
        const endpoint = api ? api.updateSiteSettings : null;
        if (!endpoint) {
            throw new Error("Could not resolve endpoint");
        }

        const profile = await WyanokeUtil.loadUserProfile(true, false);
        if (!profile) {
            throw new Error("Could not resolve user.");
        }

        if(profile.isLoggedIn === "False" || profile.sitesettings === undefined) {
            throw new Error("Not Allowed");
        }

        profile.sitesettings.goalmodalsshown = (userSettings?.GoalModalsShown||[]);

        await FetchUtil.sendMessage(endpoint, userSettings, "no-cache", true);
        return;
    }

    public async updateProfile(fields: IUserProfileCustomField[]): Promise<boolean> {
        const api = this._api;
        const endpoint = api ? api.update : null;
        if (!endpoint) {
            throw new Error("Could not resolve endpoint");
        }

        const profile = await WyanokeUtil.loadUserProfile(true, false);
        if (!profile) {
            throw new Error("Could not resolve user.");
        }

        await FetchUtil.sendMessage(
            {
                method: endpoint.method,
                url: endpoint.url
            },
            {
                contactId: profile.contactid,
                customFields: fields
            }
        );

        return true;
    }

    public async getCustomFields(ids: string[]):Promise<IUserProfileCustomFieldResponse> {
        const api = this._api;
        const endpoint = api ? api.getCustomFields : null;
        if (!endpoint) {
            throw new Error("Could not resolve endpoint");
        }

        const profile = await WyanokeUtil.loadUserProfile(true, false);
        if (!profile) {
            throw new Error("Could not resolve user.");
        }

        const contactId = profile.contactid;
        if (!contactId) {
            throw new Error("No contactId found");
        }

        const fieldIds = ids.reduce((a, c) => `${a},${c}`);
        if (!fieldIds) {
            throw new Error("No fieldIds found");
        }

        const values = {
            contactId,
            fieldIds
        };
        const reqUrl = StringUtil.supplant(endpoint.url, values) || "";

        const result = await FetchUtil.sendMessage(
            {
                method: endpoint.method,
                url: reqUrl
            }
        );

        return result as IUserProfileCustomFieldResponse;
    }
}
